module.exports = __webpack_public_path__ + "static/media/giri.3a1f7db4.png";